__webpack_require__.p = "https://ui.gamma.us-east-1.urc.advertising.amazon.dev/";